<template>
    <div class="msg-modal-wrapper">
        <TitleBaseBox
            :title="title"
            :noButton="noButton"
            :cancelText="data.cancelText"
            :cconfirmText="data.confirmText"
            @close="close"
            @cancel="cancelClick"
            @confirm="confirmClick"
        >
            <div class="msg-content">
                <div class="message">
                    <i class="icon" :class="iconClass"></i>
                    <div :class="{'modify-line-feed': data.lineFeed}" v-html="data.message"></div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import i18n from "@/i18n";

const messageSet = () => {
    return {
        tip: {
            title: i18n.t("zhiji.common.tips"),
            iconCls: "icon-tip",
            noButton: false
        },
        error: {
            title: i18n.t("zhiji.common.error"),
            iconCls: "icon-tip",
            noButton: true
        }
    };
};

// data={type, message, cancel:Function, confirm:Function, cancelText, confirmText}
export default {
    name: "MessageModal",
    props: ["data"],
    components: {
        TitleBaseBox
    },
    computed: {
        iconClass() {
            return messageSet()[this.data.type].iconCls;
        },
        title() {
            return messageSet()[this.data.type].title;
        },
        noButton() {
            return messageSet()[this.data.type].noButton;
        }
    },
    methods: {
        close() {
            this.$emit("closeModal");
            this.data.colseHandle && this.data.colseHandle.apply(null);
        },
        cancelClick() {
            this.data.cancel && this.data.cancel.apply(null);
        },
        confirmClick() {
            this.data.confirm && this.data.confirm.apply(null);
            this.close();
        }
    }
};
</script>

<style lang="less" scoped>
.msg-modal-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .msg-content {
        min-height: 96px;
        margin-bottom: 15px;
        min-width: 440px;
        max-width: 800px;
        display: flex;
        align-items: center;
        position: relative;

        .message {
            display: inline-block;
            font-size: 16px;
            padding: 0 20px 0 36px;
            word-break: break-word;
            & > div {
                white-space: pre;
            }
            .modify-line-feed {
                white-space: pre-wrap;
            }
        }

        .icon {
            position: absolute;
            left: 5px;
            display: inline-block;
            width: 22px;
            height: 22px;
            margin-right: 15px;
            vertical-align: text-bottom;
        }

        .icon-tip {
            background: url("@{zhijiStaticImagePath}i-tip.png") no-repeat;
        }
    }
}
</style>
